// ===============================================================
// ---------------------------------------------------------------
// Dependencies
import { useEffect, useContext, Fragment, Suspense, lazy } from "react"

// Context
import AppContext from "../../Context/App/appContext"
import AppNavbar from "../Modules/AppNavbar"

// Modules
import Spinner from "../Modules/Spinner"
import Theme from "../Modules/Theme"

// Lazy Modules
const BusinessShowcase = lazy(() => import("../Modules/BusinessShowcase"))
const ForBusinessMainContent = lazy(() => import("../Modules/ForBusinessMainContent"))
const ForBusinessWhyPartner = lazy(() => import("../Modules/ForBusinessWhyPartner"))
const StuckBusiness = lazy(() => import("../Modules/StuckBusiness"))
const Footer = lazy(() => import("../Modules/Footer"))

// ===============================================================
const ForBusiness = () => {
	// ---------------------------------------------------------------
	// Context
	const appContext = useContext(AppContext)
	const { business, getBusiness } = appContext

	// ---------------------------------------------------------------
	// Scroll to top on load and fetch content
	useEffect(() => {
		window.scrollTo(0, 0)
		getBusiness()
		// eslint-disable-next-line
	}, [])

	return (
		<Fragment>
			<Suspense fallback={<Spinner />}>
				{business ? (
					<Theme id="for-business" className="for-business">
						<AppNavbar />
						<BusinessShowcase />
						<ForBusinessMainContent/>
						<ForBusinessWhyPartner/>
						<StuckBusiness />
						<Footer />
					</Theme>
				) : (
					<Spinner />
				)}
			</Suspense>
		</Fragment>
	)
}

export default ForBusiness
